var chunkMapping = {
	"37": [
		43037
	],
	"74": [
		8074
	],
	"75": [
		35075
	],
	"81": [
		67081
	],
	"84": [
		13084
	],
	"97": [
		35097
	],
	"252": [
		16252
	],
	"389": [
		35389
	],
	"703": [
		97703
	],
	"715": [
		14715
	],
	"740": [
		43740
	],
	"741": [
		23741
	],
	"749": [
		56749
	],
	"953": [
		28953
	]
};
var idToExternalAndNameMapping = {
	"8074": [
		"default",
		"./KGEntityPanel",
		68586
	],
	"13084": [
		"default",
		"./SearchMenu",
		549
	],
	"14715": [
		"default",
		"./OntologyNavigator",
		21249
	],
	"16252": [
		"default",
		"./DiagramEditor",
		1251
	],
	"23741": [
		"default",
		"./KGScanModel",
		68586
	],
	"28953": [
		"default",
		"./Research",
		42294
	],
	"35075": [
		"default",
		"./KGResolution",
		68586
	],
	"35097": [
		"default",
		"./KGDatasetSchema",
		68586
	],
	"35389": [
		"default",
		"./DataIntegration",
		11235
	],
	"43037": [
		"default",
		"./PublishedThreadPage",
		549
	],
	"43740": [
		"default",
		"./Search",
		549
	],
	"56749": [
		"default",
		"./KGEntityMetric",
		68586
	],
	"67081": [
		"default",
		"./KGEntityRelationMetric",
		68586
	],
	"97703": [
		"default",
		"./PageEditor",
		553
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}